import { IController } from 'angular';

import { SpinnerModal } from '../../../../shared/modals/status-spinner/status-spinner.service';
import { ISdcStore } from './../../../flux/sdc-store.interface';
import { IWizState } from './../../../sdc-state/sdc-state.typings';

export class GradPlanningWizardCtrl implements IController {
  static $inject: string[] = ['SpinnerModal', 'SDCStore', '$scope'];

  // bindings
  currentSchool: any;
  currentUser;
  initialWizardState: IWizState;

  // class properties
  uiReady;

  constructor(private spinnerModal: SpinnerModal, private SDCStore: ISdcStore, private $scope) {}

  $onInit() {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.spinnerModal.deactivateSpinner();
        this.uiReady = true;
      }
    });
  }
}
